import { render, staticRenderFns } from "./PaymentReceiptComponent.vue?vue&type=template&id=8f0d21e6"
import script from "./PaymentReceiptComponent.vue?vue&type=script&lang=js"
export * from "./PaymentReceiptComponent.vue?vue&type=script&lang=js"
import style0 from "./PaymentReceiptComponent.vue?vue&type=style&index=0&id=8f0d21e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports